import { type ProductData } from "~/domains/product/types/ProductData";
import Modal from "~/common/components/Modal";
import { HousingTabularViewDetailPanel } from "~/features/selectionAssistant/housing/components/VariantProductsTableModal/HousingTabularViewDetailPanel";
import classes from "~/features/selectionAssistant/housing/components/VariantProductsTableModal/VariantProductsTableModal.module.less";

interface Props {
  onClose: () => void;
  products: ProductData[];
}

export const VariantProductsTableModal = (props: Props) => {
  return (
    <Modal onClose={props.onClose} modalClassName={classes.modal} modalBgClassName={classes.modalRoot}>
      <HousingTabularViewDetailPanel products={props.products} />
    </Modal>
  );
};
